
'use strict';

class SortUtils {

	/**
	 * Сортировка массива размеров вида "100x50"
	 * @param sizeArray
	 */
	static sortSize(sizeArray) {
		sizeArray.sort((a, b) => {

			let [aw, ah] = a.split('x');
			let [bw, bh] = b.split('x');

			aw = parseInt(aw);
			ah = parseInt(ah);
			bw = parseInt(bw);
			bh = parseInt(bh);

			if (aw < bw) {
				return -1;
			}

			if (aw > bw) {
				return 1;
			}

			if (ah < bh) {
				return -1;
			}

			if (ah > bh) {
				return 1;
			}

			return 0;

		});
	}

}

module.exports = SortUtils;



// WEBPACK FOOTER //
// ./src/react/utils/SortUtils.js